import { ComponentFactoryResolver, ComponentRef, Directive, ElementRef, HostListener, Input, Renderer2, ViewContainerRef } from '@angular/core';
import { TooltipComponent } from 'src/app/component/shared/tooltip/tooltip.component';
import * as _ from 'underscore';


@Directive({
  selector: '[appCustomTooltip]'
})
export class CustomTooltipDirective {
  @Input('appCustomTooltip') tooltipContent: any;
  tooltipElement: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) { }


  // Mouse enters the element, show the tooltip
  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltipElement) {
      this.createTooltip();
    }
    this.renderer.setStyle(this.tooltipElement, 'opacity', '1');
  }

  // Mouse moves within the element, update the tooltip position
  @HostListener('mousemove', ['$event']) onMouseMove(event: MouseEvent) {
    if (this.tooltipElement) {
      this.renderer.setStyle(this.tooltipElement, 'left', `${event.pageX + 10}px`);
      this.renderer.setStyle(this.tooltipElement, 'top', `${event.pageY + 10}px`);
    }
  }

  // Mouse leaves the element, hide the tooltip
  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltipElement) {
      this.renderer.setStyle(this.tooltipElement, 'opacity', '0');
      this.renderer.removeChild(document.body, this.tooltipElement);
      this.tooltipElement = null;
    }
  }

  // Create the tooltip element
  private createTooltip() {
    this.tooltipElement = this.renderer.createElement('div');
    this.renderer.appendChild(document.body, this.tooltipElement);

    // Tooltip container styles
    this.renderer.addClass(this.tooltipElement, 'tooltip');
    this.renderer.setStyle(this.tooltipElement, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipElement, 'backgroundColor', '#293462'); // Dark background
    this.renderer.setStyle(this.tooltipElement, 'color', '#fff'); // White text
    this.renderer.setStyle(this.tooltipElement, 'padding', '10px');
    this.renderer.setStyle(this.tooltipElement, 'borderRadius', '8px');
    this.renderer.setStyle(this.tooltipElement, 'pointerEvents', 'none');
    this.renderer.setStyle(this.tooltipElement, 'transition', 'opacity 0.2s ease-in-out, transform 0.2s ease-in-out');
    this.renderer.setStyle(this.tooltipElement, 'zIndex', '9999');
    this.renderer.setStyle(this.tooltipElement, 'opacity', '1');
    this.renderer.setStyle(this.tooltipElement, 'boxShadow', '0 4px 6px rgba(0, 0, 0, 0.2)');
    this.renderer.setStyle(this.tooltipElement, 'fontSize', '14px');
    this.renderer.setStyle(this.tooltipElement, 'fontWeight', '500');
    this.renderer.setStyle(this.tooltipElement, 'fontFamily', 'Arial, sans-serif');
    this.renderer.setStyle(this.tooltipElement, 'border', '1px solid rgba(255, 255, 255, 0.2)');
    this.renderer.setStyle(this.tooltipElement, 'display', 'flex'); // Align items in a row
    this.renderer.setStyle(this.tooltipElement, 'flex-direction', 'column'); // Align items in a row
    this.renderer.setStyle(this.tooltipElement, 'gap', '8px'); // Space between badges
    this.renderer.setStyle(this.tooltipElement, 'alignItems', 'start');
    this.renderer.setStyle(this.tooltipElement, 'justifyContent', 'start');
    this.renderer.setStyle(this.tooltipElement, 'flexWrap', 'wrap'); // Allow wrapping for multiple names

    // Set tooltip content as badges
    if (typeof this.tooltipContent === 'object') {
      let viewers = this.tooltipContent.viewers;
      viewers = _.uniq(viewers).sort();
      const driver = this.tooltipContent.drivers;
      const staff = this.tooltipContent.staffs;
      const company = this.tooltipContent.company;
      let filteredViewers: any = [];

      for (let item of viewers) {
        if (driver[item]) {
          filteredViewers.push(driver[item].displayName);
        } else if (staff[item]) {
          filteredViewers.push(staff[item].displayName);
        } else {
          filteredViewers.push(company.displayName);
        }
      }

      filteredViewers.forEach(name => {
        const badge = this.renderer.createElement('span');
        this.renderer.setStyle(badge, 'backgroundColor', '#293462'); // Dark badge color
        this.renderer.setStyle(badge, 'color', '#fff');
        this.renderer.setStyle(badge, 'padding', '6px 12px');
        this.renderer.setStyle(badge, 'borderRadius', '16px'); // Rounded badge
        this.renderer.setStyle(badge, 'fontSize', '12px');
        this.renderer.setStyle(badge, 'fontWeight', 'bold');
        this.renderer.setStyle(badge, 'display', 'inline-block');
        this.renderer.setStyle(badge, 'textAlign', 'center');
        this.renderer.setStyle(badge, 'whiteSpace', 'nowrap');

        const text = this.renderer.createText(name);
        this.renderer.appendChild(badge, text);
        this.renderer.appendChild(this.tooltipElement, badge);
      });
    } else {
      const text = this.renderer.createText(this.tooltipContent);
      this.renderer.appendChild(this.tooltipElement, text);
    }
  }



  // Remove the tooltip element on directive destroy
  ngOnDestroy() {
    if (this.tooltipElement) {
      this.renderer.removeChild(document.body, this.tooltipElement);
    }
  }
  // private setPosition(event: MouseEvent, tooltipElement: HTMLElement) {
  //   const pageWidth = window.innerWidth;
  //   const pageHeight = window.innerHeight;
  //   const tooltipRect = tooltipElement.getBoundingClientRect();

  //   // Default positions
  //   let top = event.pageY + this.tooltipOffset;
  //   let left = event.pageX + this.tooltipOffset;

  //   // Check for available space on all sides
  //   const fitsBelow = top + tooltipRect.height <= pageHeight;
  //   const fitsAbove = top - tooltipRect.height >= 0;
  //   const fitsRight = left + tooltipRect.width <= pageWidth;
  //   const fitsLeft = left - tooltipRect.width >= 0;

  //   // Determine the best position based on available space
  //   if (fitsBelow) {
  //     // Position below the element
  //     top = event.pageY + this.tooltipOffset;
  //   } else if (fitsAbove) {
  //     // Position above the element
  //     top = event.pageY - tooltipRect.height - this.tooltipOffset;
  //   }

  //   // Check horizontal positioning after deciding vertical position
  //   if (fitsRight) {
  //     // Position to the right of the element
  //     left = event.pageX + this.tooltipOffset;
  //   } else if (fitsLeft) {
  //     // Position to the left of the element if not enough space on the right
  //     left = event.pageX - tooltipRect.width - this.tooltipOffset;
  //   } else {
  //     // If neither left nor right fits, position center if below or above
  //     left = event.pageX - (tooltipRect.width / 2);
  //   }

  //   // Apply calculated positions
  //   tooltipElement.style.top = `${top}px`;
  //   tooltipElement.style.left = `${left}px`;
  // }

}
